import { captureException, captureMessage } from "@sentry/nextjs";

const pluralize = (value: number, singular: string, plural: string): string =>
  value === 1 ? `há ${value} ${singular}` : `há ${value} ${plural}`;

export const formatTimeAgo = (dateString: string): string => {
  let result = "";

  try {
    const now = new Date();
    const date = new Date(dateString);
    const diffInSeconds = Math.floor(
      ((now as unknown as number) - (date as unknown as number)) / 1000,
    );

    const diffInMinutes = Math.floor(diffInSeconds / 60);

    if (diffInMinutes <= 0) return "há poucos minutos";

    if (diffInMinutes < 60)
      return pluralize(diffInMinutes, "minuto", "minutos");

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return pluralize(diffInHours, "hora", "horas");

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) return pluralize(diffInDays, "dia", "dias");

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) return pluralize(diffInMonths, "mês", "meses");

    const diffInYears = Math.floor(diffInMonths / 12);
    result = pluralize(diffInYears, "ano", "anos");
  } catch (error) {
    console.log("Erro (formatTimeAgo): ", error);
    captureException(error);
    captureMessage("Erro (formatTimeAgo)");
  }

  return result;
};
